import React, { Component } from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
// import { Switch,  } from "react-router";
import FontStyles from "./fontStyles";
// components
import { NoMatch } from "./pages";
import routes, { default as PrivateRoute } from "./routes";

// context
import {
  AuthContext,
  SubscriberContext,
  ThemeContext,
  LoyaltyContext,
  TriviaContext,
  MotivationalContext,
  SpinTheWheelContext,
} from "./context";
import FastestFingerContext from "./context/FastestFingerContext";
import RatingsContext from "./context/RatingsContext";

class App extends Component {
  render() {
    return (
      <AuthContext.ProviderWrapper>
        <ThemeContext.ProviderWrapper>
          <TriviaContext.ProviderWrapper>
            <SubscriberContext.ProviderWrapper>
              <FastestFingerContext.ProviderWrapper>
                <LoyaltyContext.ProviderWrapper>
                  <RatingsContext.ProviderWrapper>
                    <SpinTheWheelContext.ProviderWrapper>
                      <MotivationalContext.ProviderWrapper>
                        <FontStyles />
                        <BrowserRouter>
                          <Switch>
                            {routes.map(
                              ({
                                path,
                                exact,
                                isPrivate,
                                component: Component,
                                ...rest
                              }) => {
                                return (
                                  <Route
                                    key={path}
                                    path={path}
                                    exact={exact}
                                    render={(props) => (
                                      <Component {...props} {...rest} />
                                    )}
                                  />
                                );
                              }
                            )}

                            <Route render={(props) => <NoMatch {...props} />} />
                          </Switch>
                        </BrowserRouter>
                      </MotivationalContext.ProviderWrapper>
                    </SpinTheWheelContext.ProviderWrapper>
                  </RatingsContext.ProviderWrapper>
                </LoyaltyContext.ProviderWrapper>
              </FastestFingerContext.ProviderWrapper>
            </SubscriberContext.ProviderWrapper>
          </TriviaContext.ProviderWrapper>
        </ThemeContext.ProviderWrapper>
      </AuthContext.ProviderWrapper >
    );
  }
}

export default App;
